import axios from 'axios'
import {constyjyp} from './constyjyp';
import router from './../router';
import * as appUtils from "./appUtils";
import { apis } from "./apis";


axios.interceptors.request.use(function (config) {
    // debugger
    let token = appUtils.getLocalStorage(constyjyp.TOKEN_KEY);  //从缓存中取token
    // console.log(appUtils.getLocalStorage(constyjyp.JTI));
    if (token) {
        if(apis.imageUpload != config.url){
            config.headers.Authorization = 'Bearer ' + token;   //将token放到请求头发送给服务器
        }
        // const url = new URL(config.url);
        // url.searchParams.set('appId', appUtils.getAppId());
        // config.url = url.toString();
    } else if(appUtils.getLocalStorage(constyjyp.JTI)){
        return config;
    } else {
        localStorage.removeItem(constyjyp.TOKEN_KEY);  //清空缓存
        localStorage.removeItem(constyjyp.JTI);  //清空缓存
        localStorage.removeItem(constyjyp.USER_INFO);  //清空缓存
        if(window.location.pathname.indexOf('/login') == -1){
            if(window.location.pathname.indexOf('project')>-1){
            }
            else if(window.location.pathname.indexOf('tempView')>-1){
            }
            else if(window.location.pathname.indexOf('forgetPwd')>-1){
            }
            else if(window.location.pathname.indexOf('changePwd')>-1){
            }
            else if(window.location.pathname.indexOf('changePassWord')>-1){
            }
            else if(window.location.pathname.indexOf('changeEmail')>-1){
            }
            else{
                router.push({path:'/login'});
            }
        }
        // console.log(window.location.pathname);
        return config;
    }
    return config;
}, function (err) {
    return Promise.reject(err);
});


// http response 拦截器
axios.interceptors.response.use(
    response => {
        // console.log(response);
        switch (response.data.status) {
            case 1001:
                router.push({path:'/login'});
                break;
            default:
                    return response;
        }
        return response;  //请求成功的时候返回的data
    },
    error => {
        // console.log(error);
        try {
            if (error.response) {
                switch (error.response.status) {
                    case 1001:
                        router.push({path:'/login'});
                        break;
                    case 500:
                        console.log("http状态码:500");
                        break;
                    case 404:
                        console.log("http状态码:404");
                        break;
                    default:
                        return Promise.reject(error)
                }
            }
            return Promise.reject(error.response.data)
        }
        catch (e) {

        }
});





// WEBPACK FOOTER //
// ./src/core/interceptors.js